import {
  Box,
  Container,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useLanguage } from "../context/LanguageContext";

function Footer() {
  const { language } = useLanguage();
  const year = new Date().getFullYear();

  const tagline =
    language === "es"
      ? "Construyendo cosas que importan."
      : "Building things that matter.";

  return (
    <Box
      bg={useColorModeValue("blue.50", "blue.900")}
      color={useColorModeValue("gray.700", "text.muted")}
    >
      <Container as={Stack} maxW={"6xl"} py={4} align="center" spacing={1}>
        <Text fontSize="sm">&copy; {year} Héctor Durán</Text>
        <Text fontSize="xs" color="text.muted">
          {tagline}
        </Text>
      </Container>
    </Box>
  );
}

export default Footer;
